// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TkZp","importantInfo":"styles_importantInfo__TITtR"};